import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>Made with ❤ in Bandung</p>
    </footer>
  );
}
